import { JsonSchemaType, RegularJsonSchema } from '@evidentid/json-schema/interfaces/JsonSchema';
import { CriterionTemplate } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';

interface Params {
    template: CriterionTemplate;
}

export const getFlagDisabledReferenceValueType = ({ template }: Params): JsonSchemaType | null => {
    const conditionalRefs = template.displayMetadata.conditionalValueReference;

    if (!conditionalRefs) {
        return null;
    }

    const schema = template.evaluator.references[conditionalRefs.flagDisabledReference]?.schema;
    return (schema as RegularJsonSchema)?.type || null;
};
